/* global axios */
import ApiClient from './ApiClient';

class WahaIntegrationsAPI extends ApiClient {
  constructor() {
    super('waha_integrations', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  create(data) {
    return axios.post(this.url, {
      inbox_name: data.inboxName,
      waha_server_url: data.wahaServerUrl,
      waha_api_key: data.wahaApiKey,
      chatwoot_url: data.chatwootUrl,
    });
  }

  delete(id, params) {
    return axios.delete(`${this.url}/${id}`, {
      params: {
        waha_server_url: params.wahaServerUrl,
        waha_api_key: params.wahaApiKey,
      },
    });
  }

  getSessionStatus(sessionName) {
    return axios.get(`${this.url}/session/${sessionName}/status`);
  }

  getQRCode(sessionName) {
    return axios.get(`${this.url}/session/${sessionName}/qr`);
  }

  startSession(sessionName) {
    return axios.post(`${this.url}/session/${sessionName}/start`);
  }

  stopSession(sessionName) {
    return axios.post(`${this.url}/session/${sessionName}/stop`);
  }

  restartSession(sessionName) {
    return axios.post(`${this.url}/session/${sessionName}/restart`);
  }

  logoutSession(sessionName) {
    return axios.post(`${this.url}/session/${sessionName}/logout`);
  }
}

export default new WahaIntegrationsAPI();
